import {
	animate,
	createSpring,
	createTimeline,
	onScroll,
	stagger,
	utils,
} from "animejs";
import { rem } from "./ultil";
import { SplitText } from "gsap/SplitText";
import Wave from "./wave";

const homeSection = utils.$("section[class*='home']");
const langauge = document.documentElement.lang;
const isVietnamese = langauge === "vi-VN" ? true : false;

export const homePage = {
	home_items_animation: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry, index) => {
					if (entry.intersectionRatio > 0.5) {
						animate(entry.target.querySelectorAll(".item"), {
							opacity: [0, 1],
							y: [rem(40), 0],
							ease: createSpring({
								stiffness: 150,
							}),
							delay: stagger(100),
							duration: 600,
						});
						obs.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.5 }
		);

		utils.$(".home-item-animation").forEach((el) => {
			utils.set(el.querySelectorAll(".item"), {
				opacity: 0,
				y: rem(40),
			});
			observer.observe(el);
		});
	},
	homeBlockTitles: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0.5) {
						const title = entry.target;
						const position =
							window.getComputedStyle(title).textAlign;
						const splitText = SplitText.create(title, {
							type: "chars,words",
						});
						title.style.opacity = 1;
						const { chars, words } = splitText;
						words.forEach((word, wordIndex) => {
							word.style.overflow = "hidden";
							word.style.display = "inline-flex";
							const children = word.children;
							if (!children) return;
							const reverseIndex = words.length - wordIndex - 1;
							Array.from(children).forEach(
								(child, childIndex) => {
									animate(child, {
										opacity: [0, 1],
										x: ["-100%", 0],
										duration: 1000,
										ease: createSpring({
											stiffness: 150,
										}),
										delay: wordIndex * 100,
										onComplete: () => {
											word.style.overflow = "visible";
										},
									});
								}
							);
						});
						obs.unobserve(title); // Only animate once
					}
				});
			},
			{
				threshold: 0.5, // Adjust as needed (20% visible)
			}
		);
		const blockTitles = document.querySelectorAll(
			".block-title,.animate-heading"
		);
		if (blockTitles.length === 0) return;
		blockTitles.forEach((title) => {
			const notAnimated = title.classList.contains("not-animated");
			if (notAnimated) return;
			title.style.opacity = 0;
			observer.observe(title);
		});
	},
	homeTitle: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0.5) {
						const title = entry.target;
						const animateStyle =
							title.getAttribute("animate-title") || "fade-up";
						const position =
							window.getComputedStyle(title).textAlign;
						let animateFrom = "first";
						if (position === "center") {
							animateFrom = "center";
						}
						if (position === "right") {
							animateFrom = "last";
						}

						const splitText = SplitText.create(title, {
							type: "words",
						});

						title.style.overflow = "hidden";

						if (animateStyle === "fade-up") {
							animate(splitText.words, {
								opacity: [0, 1],
								y: ["100%", 0],
								duration: 600,
								ease: createSpring({
									stiffness: 150,
								}),
								delay: stagger(25, {
									from: animateFrom,
								}),
							});
						}
						if (animateStyle === "slide-up") {
							animate(splitText.words, {
								opacity: [0, 1],
								x: ["100%", 0],
								duration: 600,
								ease: createSpring({
									stiffness: 150,
								}),
								delay: stagger(25, {
									from: animateFrom,
								}),
							});
						}

						obs.unobserve(title); // Only animate once
					}
				});
			},
			{
				threshold: 0.5,
			}
		);

		homeSection.forEach((home) => {
			const title = home.querySelectorAll("[animate-title]");
			if (!title) return;
			title.forEach((item) => {
				observer.observe(item);
			});
		});
	},
	homeDescription: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const description = entry.target;
						let animateFrom = "first";
						// const position =
						// 	window.getComputedStyle(description).textAlign;
						// if (position === "center") {
						// 	animateFrom = "center";
						// } else if (position === "right") {
						// 	animateFrom = "last";
						// }

						const splitText = SplitText.create(description, {
							type: "words,lines",
						});
						description.style.opacity = 1;
						const words = splitText.words;
						const line = splitText.lines;
						line.forEach((line) => {
							line.style.height = line.offsetHeight + "px";
							line.style.overflow = "hidden";
						});
						animate(words, {
							opacity: [0, 1],
							translateY: [rem(20), 0],
							duration: 500,
							delay: stagger(15, {
								from: animateFrom,
							}),
						});
						obs.unobserve(description); // Only animate once
					}
				});
			},
			{
				threshold: 0.2, // Adjust as needed (20% visible)
			}
		);

		homeSection.forEach((home) => {
			const description = home.querySelector(".description");
			if (!description) return;
			const notAnimated = description.classList.contains("not-animated");
			if (notAnimated) return;
			description.style.opacity = 0;
			observer.observe(description);
		});
	},
	homeButtons: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const wrap = entry.target;
						animate(wrap, {
							opacity: [0, 1],
							y: [45, 0],
							duration: 500,
						});
						obs.unobserve(wrap); // Only animate once
					}
				});
			},
			{
				threshold: 0.2, // Adjust as needed (20% visible)
			}
		);

		homeSection.forEach((home) => {
			const buttons = home.querySelectorAll(".btn");
			const wrappers = [];

			buttons.forEach((button) => {
				const notAnimate = button.classList.contains("not-animated");
				if (notAnimate) return;
				// Create wrapper div
				const wrap = document.createElement("div");
				wrap.classList.add("button-wrapper");

				// Get the button's parent
				const parent = button.parentNode;

				// Insert the wrapper where the button was
				parent.insertBefore(wrap, button);

				// Move the button into the wrapper
				wrap.appendChild(button);

				// Store the wrapper reference
				wrap.style.opacity = 0;
				wrap.style.y = rem(45);
				wrappers.push(wrap);
			});

			if (wrappers.length === 0) return;

			// Observe each wrapper for intersection
			wrappers.forEach((wrap) => {
				observer.observe(wrap);
			});
		});
	},
	homeImages: () => {
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry, index) => {
				const target = entry.target;
				const animateType =
					target.getAttribute("animate-image") || "fade-up";
				const image = target.querySelector("img");
				if (!image) return;
				image.onload = () => {
					if (animateType === "fade-up") {
						animate(target, {
							opacity: [0, 1],
							y: ["50%", 0],
							ease: createSpring({
								stiffness: 150,
							}),
							delay: stagger(100),
							duration: 600,
						});
					}
					if (animateType === "fade-left") {
						animate(target, {
							opacity: [0, 1],
							x: ["50%", 0],
							ease: "outQuart",
							duration: 600,
						});
					}
					obs.unobserve(entry.target);
				};
			});
		});

		utils.$("[animate-image]").forEach((el) => {
			observer.observe(el);
		});
	},
	primaryNav: () => {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						animate(entry.target.querySelectorAll("li"), {
							opacity: 1,
							x: 0,
							duration: 600,
							delay: stagger(100),
							ease: createSpring({
								stiffness: 150,
								damping: 10,
							}),
						});
						obs.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.2 }
		);

		utils.$(".primary-nav, .secondary-nav").forEach((el) => {
			utils.set(el.querySelectorAll("li"), {
				opacity: 0,
				x: rem(20),
			});
			observer.observe(el);
		});
	},
	first_section_prop: () => {
		const props = utils.$(".home-page-wrapper .prop");
		const tl = createTimeline({
			autoplay: false,
			defaults: {
				duration: 2000,
			},
		});
		let isPlay = [];
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (isPlay.length < 2) {
						isPlay.push(true);
					}
					if (isPlay.length === 2) {
						tl.play();
					}
				}
			});
		});
		props.forEach((item) => {
			const isProp_1 = item.classList.contains("prop-1");
			const isProp_2 = item.classList.contains("prop-2");
			if (isProp_1) {
				tl.add(item, {
					opacity: [0, 1],
					right: ["-20%", "-17%"],
					top: ["-10%", "-1%"],
					ease: createSpring({
						stiffness: 50,
					}),
					onBegin: () => {
						item.style.opacity = 1;
					},
					onComplete: () => {
						// obs.unobserve(item);
					},
				});
			}
			if (isProp_2) {
				tl.add(
					item.querySelector("img"),
					{
						opacity: [0, 1],
						scale: [1, 1.5],
						onBegin: () => {
							item.style.opacity = 1;
						},
						onComplete: () => {
							// obs.unobserve(item);
						},
					},
					"*=.3"
				);
			}
			observer.observe(item);
		});
	},
	home_1: () => {
		homeSection.forEach((home) => {
			if (!home.classList.contains("home-1")) return;

			const observer = new IntersectionObserver((entries, obs) => {
				const tl = createTimeline({
					autoplay: false,
					onBegin: () => {
						home.style.opacity = 1;
					},
					onComplete: () => {
						obs.unobserve(home);
					},
				});
				entries.forEach((entry) => {
					const home = entry.target;
					const wrapTitle = home.querySelector(".wrap-title");
					const wrapTitleInner =
						home.querySelector(".wrap-title-inner");
					const wrapDescription =
						home.querySelector(".wrap-description");
					const description = home.querySelector(".description");
					const img = home.querySelector(".img");
					if (wrapTitle && wrapTitleInner) {
						wrapTitle.style.overflow = "hidden";
						utils.set(wrapTitleInner, {
							x: "100%",
						});
						tl.add(wrapTitleInner, {
							x: 0,
							ease: "outQuart",
							onComplete: () => {
								wrapTitle.style.overflow = "visible";
							},
						});
					}
					if (wrapDescription && description) {
						wrapDescription.style.overflow = "hidden";
						utils.set(description, {
							x: "100%",
						});
						tl.add(
							description,
							{
								x: 0,
								ease: "outQuart",
								onComplete: () => {
									wrapDescription.style.overflow = "visible";
								},
							},
							"*=.5"
						);
					}
					if (img) {
						const imgTag = img.querySelector("img");
						utils.set(imgTag, {
							x: "-100%",
						});
						tl.add(
							imgTag,
							{
								x: 0,
								opacity: 1,
								ease: "outQuart",
							},
							"<<"
						);
					}

					if (entry.isIntersecting) {
						//
						tl.play();
					}
				});
			});
			observer.observe(home);
		});
	},

	stringsWave: () => {
		const stringsWave = utils.$(".strings-wave");
		stringsWave.forEach((item, index) => {
			const stringInner = item.querySelector(".string-inner");
			const newCanvas = document.createElement("canvas");
			newCanvas.id = `wave-canvas-${index}`;
			stringInner.appendChild(newCanvas);
			const wave = new Wave({
				el: newCanvas,
				unit: stringInner.offsetHeight * 0.6,
			});
			wave.stop();
			const observer = new IntersectionObserver((entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						wave.start();
					} else {
						wave.stop();
					}
				});
			});
			observer.observe(item);
		});
	},
	home_2: () => {
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry, index) => {
				const tl = createTimeline({
					autoplay: false,
					defaults: {
						duration: 500,
					},
					onComplete: () => {
						obs.unobserve(entry.target);
					},
				});
				const items = entry.target.querySelectorAll(".item");
				if (items.length === 0) return;
				items.forEach((item, itemIndex) => {
					utils.set(item, {
						opacity: 0,
						y: "-10%",
					});
					tl.add(item, {
						opacity: 1,
						y: 0,
					});
					tl.add(
						item.querySelector(".circle"),
						{
							opacity: 1,
							// scale: 1,
						},
						"*=.5"
					);
				});

				if (entry.isIntersecting) {
					tl.play();
				}
			});
		});
		homeSection.forEach((home) => {
			if (home.classList.contains("home-2")) {
				observer.observe(home);
			}
		});
	},
	home_3: () => {
		homeSection.forEach((home) => {
			if (!home.classList.contains("home-3")) return;

			const items = home.querySelectorAll(".item");
			if (items.length === 0) return;
			items.forEach((item, index) => {
				const tl = createTimeline({
					autoplay: false,
					defaults: {
						duration: 800,
					},
				});
				const image = item.querySelector(".img");
				const content = item.querySelector(".wrapper");
				const isEven = index % 2 === 0;
				utils.set(image, {
					opacity: 0,
					x: isEven ? "10%" : "-10%",
				});
				const startX = isEven ? "-10%" : "10%";
				utils.set(content, {
					opacity: 0,
					x: startX,
				});
				tl.add(image, {
					opacity: 1,
					x: 0,
					onUpdate: (anim) => {
						const progress = anim.progress;
						const currentX = (isEven ? -10 : 10) * (1 - progress);

						utils.set(content, {
							opacity: 1,
							x: `${currentX}%`,
						});
					},
				});
				const observer = new IntersectionObserver((entries, obs) => {
					entries.forEach((entry, index) => {
						if (entry.isIntersecting) {
							tl.play();
						}
					});
				});
				observer.observe(item);
			});
		});
	},
	init: () => {
		homePage.first_section_prop();
		homePage.stringsWave();
		if ($(".home").length === 0) return;
		if ($(window).width() < 1200) return;
		homePage.home_3();
		homePage.primaryNav();
		homePage.home_items_animation();
		homePage.homeButtons();
		homePage.homeImages();
		document.fonts.ready.then((e) => {
			homePage.home_1();

			homePage.homeBlockTitles();
			homePage.homeTitle();
			homePage.homeDescription();
		});
	},
};
